/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Zns_Phone_InvalidInputs */

const vi_error_zns_phone_invalid = /** @type {(inputs: Error_Zns_Phone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số điện thoại chưa đúng — nhập 10 số bắt đầu bằng 0.`)
};

/**

* @param {Error_Zns_Phone_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zns_phone_invalid = /** @type {((inputs?: Error_Zns_Phone_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zns_Phone_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zns_phone_invalid(inputs)
});